module.exports = __webpack_public_path__ + "static/media/PalletTrader_FC Member Portraits_Mortimer .562dc0f2.webp";